import { Image } from "@mantine/core"
import React from "react"
import telmedaLogo from "../../assets/images/telmeda_icononly_transparent_nobuffer.png"
import telmedaLogoTitle from "../../assets/images/telmeda_logo_title_transparent.png"

interface Props {
    width: number
    full?: boolean
}

export default function TelmedaLogo({ width, full }: Props) {
    return full ? (
        <Image src={telmedaLogoTitle} w={width} />
    ) : (
        <Image src={telmedaLogo} w={width} />
    )
}
